import { SET_BROKER_LOAN_APPLICATION_ID } from './types'

export const setBrokerLoanApplicationId = (blaId, fromBroker) => ({
  blaId,
  fromBroker,
  type: SET_BROKER_LOAN_APPLICATION_ID,
})
